module.exports = " <div class=container _v-2c4a0ff9=\"\"> <div class=row _v-2c4a0ff9=\"\"> <div class=form-container _v-2c4a0ff9=\"\"> <h2 class=\"title-center header-no-padding-bottom\" _v-2c4a0ff9=\"\">Login</h2> <div class=\"col-sm-6 col-sm-offset-3\" _v-2c4a0ff9=\"\"> <login _v-2c4a0ff9=\"\"></login> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-2c4a0ff9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 605
// module chunks = 0